import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { map } from 'rxjs/operators';
// import { environment } from '../../../../environments/environment';

import { API } from 'aws-amplify';
import { Observable } from 'rxjs';
import { ConfigService } from '../../config';

@Injectable({
  providedIn: 'root'
})
export class BulkHttpService {

    apiName: string;

    constructor(private http: HttpClient, private configService: ConfigService) {
        this.apiName = this.configService.get('host');
    }

	getRegions() {
		return new Observable((observer: any) => {
			const path = '/dashboard/get-regions';
			const myInit = {
				response: false
			};
			API.get(this.apiName, path, myInit).then(response => {
			  observer.next(response);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	getStageStatus(): Observable<any> {
		return new Observable((observer: any) => {
			const path = '/dashboard/stage-status';
			const myInit = {
				response: false
			};
			API.get(this.apiName, path, myInit).then(response => {
			  console.log(response);
			  observer.next(response);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	getTerritories(queryParams) {
		return new Observable((observer: any) => {
			const path = '/dashboard/get-territories';
			const myInit = {
				response: false,
				queryStringParameters: queryParams
			};
			API.get(this.apiName, path, myInit).then(response => {
			  observer.next(response);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	getVersions(queryParams) {
		return new Observable((observer: any) => {
			const path = '/dashboard/get_versions';
			const myInit = {
				response: false,
				queryStringParameters: queryParams
			};
			API.get(this.apiName, path, myInit).then(response => {
			  observer.next(response);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	// getMachines(queryParams) {
	// 	return new Observable((observer: any) => {
	// 		const path = '/dashboard/get_all_macs';
	// 		const myInit = {
	// 			response: false,
	// 			queryStringParameters: queryParams
	// 		};
	// 		API.get(this.apiName, path, myInit).then(response => {
	// 		  observer.next(response.data);
	// 		}).catch(err => {
	// 			console.log(err.response);
	// 			observer.error(err);
	// 		});
	// 	});
	// }

	getAllVersions(queryParams) {
		return new Observable((observer: any) => {
			const path = '/dashboard/get_all_macs_version';
			const myInit = {
				response: false,
				queryStringParameters: queryParams
			};
			API.get(this.apiName, path, myInit).then(response => {
			  observer.next(response.data);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	assignBulkUpdates(formObj): Observable<any> {
		return new Observable((observer: any) => {
			const path = '/dashboard/bulk-update';
			const params = {
				body: formObj
			};
			API.post(this.apiName, path, params).then(result => {
				observer.next(result.data);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}

	updateMacCategory(formObj): Observable<any> {
		return new Observable((observer: any) => {
			const path = '/dashboard/update-mac-category';
			const params = {
				body: formObj
			};
			API.post(this.apiName, path, params).then(result => {
				observer.next(result);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}
}
